(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/grassroots-partner/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/modules/grassroots-partner/assets/javascripts/prescript.js');
"use strict";


(function (svs) {
  'use strict';

  svs = svs || {};
  svs.grassroots_partner = svs.grassroots_partner || {};
  svs.grassroots_partner.actions = svs.grassroots_partner.actions || {};
  svs.grassroots_partner.reducers = svs.grassroots_partner.reducers || {};
})(svs);

 })(window);